import { Injectable } from '@angular/core';

import {
    PcvizCollageCloudDriver,
    PcvizCollageWebFileBrowser,
    PcvizBaseDriver,
    PcvizExporterService,
    PcvizCollageWebFileBrowserConstructor,
} from '@mirage-projects/cw-models';

@Injectable({ providedIn: 'root' })
export class DataAccessPcvizService {
    createCollageCloudDriver(): PcvizCollageCloudDriver {
        return new PointCloudViz.DataAccess.CollageCloudDriver();
    }

    createCollageWebFileBrowser(): PcvizCollageWebFileBrowser {
        return new (PointCloudViz.DataAccess.CollageWebFileBrowser as PcvizCollageWebFileBrowserConstructor)();
    }

    getCollageWebFileBrowser(): typeof PointCloudViz.DataAccess.CollageWebFileBrowser {
        return PointCloudViz.DataAccess.CollageWebFileBrowser;
    }

    getDriver(idDriver: string): any {
        return PointCloudViz.DataAccess.DriverRegistry.getInstance().getDriver(idDriver);
    }

    getBaseDriver(): PcvizBaseDriver {
        return PointCloudViz.DataAccess.BaseDriver;
    }

    getExporterRegistry(): typeof PointCloudViz.DataAccess.ExporterRegistry {
        return PointCloudViz.DataAccess.ExporterRegistry;
    }

    getExporterRegistryInstance(): PcvizExporterService {
        return PointCloudViz.DataAccess.ExporterRegistry.getInstance();
    }
}
